import React from 'react';

const MESSAGE = 'Website under development — some features and content may change';

const AnnouncementBar = () => {
  const items = Array(6).fill(MESSAGE);
  return (
    <div
      data-testid="dev-banner"
      className="fixed top-0 left-0 right-0 z-[60] h-8 bg-[#641b4d] text-white overflow-hidden flex items-center"
    >
      <div className="dev-banner-track flex whitespace-nowrap will-change-transform">
        {[0, 1].map(group => (
          <div key={group} className="flex shrink-0">
            {items.map((m, i) => (
              <span key={i} className="mx-10 text-xs uppercase tracking-[0.2em] font-medium">
                {m}
              </span>
            ))}
          </div>
        ))}
      </div>
      <style>{`
        @keyframes devBannerScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .dev-banner-track { animation: devBannerScroll 25s linear infinite; }
      `}</style>
    </div>
  );
};

export default AnnouncementBar;
